import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable import/no-extraneous-dependencies */

/* eslint-disable no-underscore-dangle */
import React from "react"; // eslint-disable-next-line

// eslint-disable-next-line
var fetchMock;

var StorybookMockFetch = /*#__PURE__*/function (_React$Component) {
  _inherits(StorybookMockFetch, _React$Component);

  var _super = _createSuper(StorybookMockFetch);

  function StorybookMockFetch() {
    _classCallCheck(this, StorybookMockFetch);

    return _super.apply(this, arguments);
  }

  _createClass(StorybookMockFetch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      fetchMock = require("fetch-mock");
      this.mock();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (fetchMock.__prevProxy === this) {
        this.unmock();
      }
    }
  }, {
    key: "mock",
    value: function mock() {
      var _this = this;

      // Clear mocks from a previous StorybookMockFetch
      this.unmock();

      if (!this.props.mocks || !this.props.mocks.length) {
        return;
      }

      this.props.mocks.forEach(function (mock) {
        fetchMock.mock(_objectSpread(_objectSpread({}, mock), {}, {
          response: function response() {
            var response = _this.mockResponse(mock);

            return response;
          }
        }));
      }); // Allow unmocked requests to fall through

      fetchMock["catch"](function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return fetchMock.realFetch.apply(window, args);
      });
      fetchMock.__prevProxy = this;
    }
  }, {
    key: "mockResponse",
    value: function mockResponse(mockRequest) {
      var _this2 = this;

      var result = {
        body: mockRequest.response,
        headers: new Headers({
          "content-type": "application/json"
        })
      };

      if (mockRequest.response.hasOwnProperty("body") || mockRequest.response.hasOwnProperty("status") || mockRequest.response.hasOwnProperty("headers")) {
        result = _objectSpread(_objectSpread({}, result), mockRequest.response);
      }

      return this.props.throttle ? new Promise(function (resolve) {
        setTimeout(function () {
          return resolve(result);
        }, _this2.props.throttle);
      }) : result;
    }
  }, {
    key: "unmock",
    value: function unmock() {
      if (typeof fetchMock.restore === "function") {
        fetchMock.restore();
        delete fetchMock.__prevProxy;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return StorybookMockFetch;
}(React.Component);

_defineProperty(StorybookMockFetch, "displayName", "StorybookMockFetch");

_defineProperty(StorybookMockFetch, "defaultProps", {
  throttle: 300
});

export { StorybookMockFetch as default };